import React from 'react';

// Shared Group By segmented control for list pages (Briefs, Suppliers,
// and future list pages with grouped views). Replaces the inline
// segment markup that lived in Briefs.js so both pages render
// identical chrome from one source.
//
// Style + active-state lock the visual register: same dark pill
// shell, same "Group by" eyebrow, same green-tinted active button,
// same hover. The only thing that varies per page is the `options`
// array — Briefs uses { None / Project / Owner / Status / Pinned },
// Suppliers uses { None / Status / Risk / Compliance / Region /
// Pinned }. Drop-in for any future list page.
//
// Props:
//   value     — currently selected option value
//   onChange  — (newValue) => void
//   options   — [{ value, label }, ...] in render order
//   label     — eyebrow text; defaults to "Group by"

export default function GroupBySelect({
  value,
  onChange,
  options,
  label = 'Group by',
}) {
  return (
    <div className="inline-flex items-center gap-1 bg-white border border-line rounded-xl px-3 py-1.5 whitespace-nowrap">
      <span className="fusion-field-label pr-2">{label}</span>
      {options.map(opt => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          aria-pressed={value === opt.value}
          className={`font-['Metropolis'] text-[11px] font-bold tracking-[2px] uppercase px-3 py-1.5 rounded-lg transition-colors ${
            value === opt.value
              ? 'bg-[#92D400]/15 text-fusion-forest'
              : 'text-[#51534A] hover:text-fusion-mid-grey'
          }`}>
          {opt.label}
        </button>
      ))}
    </div>
  );
}
